export { AppleIcon } from './AppleIcon';
export { GoogleIcon } from './GoogleIcon';
export { OutlookIcon } from './OutlookIcon';
